<div class="container">
  <app-nav *ngIf="!isHome()" class="nav"></app-nav>
  <div class="router">
    <router-outlet></router-outlet>
  </div>
</div>